import {isNil} from 'ramda';

import i18n from '@dms/i18n';

import {NullishBoolean} from 'shared/web';

import {EntityHeaderFlag} from '../components/EntityHeader/EntityHeader';

export const getVehiclePhotographedFlagProps = (
  isPhotographed: NullishBoolean
): EntityHeaderFlag | null => {
  if (isNil(isPhotographed)) {
    return null;
  }

  return isPhotographed
    ? {
        colorScheme: 'blue',
        label: i18n.t('entity.vehicle.labels.photographed'),
      }
    : {
        colorScheme: 'neutral',
        label: i18n.t('entity.vehicle.labels.notPhotographed'),
      };
};
